import React, { useEffect } from "react";
import { useForm } from "react-hook-form";

type FormValues = {
	name: string;
	business: string;
	email: string;
	phone: string;
	website: string;
	role: string;
	goals: string;
	linkedin: string;
};

export default function SalesTeamForm() {
	const {
		register,
		handleSubmit,
		reset,
		formState: { errors, isSubmitting },
  } = useForm<FormValues>();
  
  useEffect(() => {
    reset();
  },[])

	const onSubmit = async (data: FormValues) => {
			fetch(
				"https://n8n.salesmrkt.com/webhook/1ed5952a-13e9-4ab9-b583-1f4a0c00b7b2",
				{
					method: "POST",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify(data),
				}
			).catch((error) => {
				console.error(error);
				alert(" Something went wrong. Please try again later.");
			});
			await new Promise((resolve) => setTimeout(resolve, 500));
			window.location.href = "/thank-you-ads";
	};

	return (
		<div className="w-full lg:-mt-16 z-40 rounded-xl bg-white p-6 mt-5 shadow-md border border-gray-200">
			<h2 className="text-2xl text-black font-bold leading-tight">
				Video Production <br />{" "}
				<span className="text-lime-500">Sales Team</span>
			</h2>
			<p className="text-sm text-gray-600 mt-1 ">Discuss a partnership</p>

			<form
				onSubmit={handleSubmit(onSubmit)}
				className="mt-6 space-y-4 flex flex-col"
			>
				{/* Name */}
				<input
					type="text"
					placeholder="Name"
					{...register("name", { required: true })}
					className="w-full border-b border-gray-300 focus:outline-none focus:border-lime-500 pb-2"
				/>
				{errors.name && (
					<span className="text-red-500 text-xs">Name is required</span>
				)}

				<input
					type="text"
					placeholder="Business"
					{...register("business", { required: true })}
					className="w-full border-b border-gray-300 focus:outline-none focus:border-lime-500 pb-2"
				/>
				{errors.business && (
					<span className="text-red-500 text-xs">Business is required</span>
				)}

				{/* Website */}
				<input
					type="text"
					placeholder="Website"
					{...register("website", {
						required: true,
						validate: (value: string) => {
							// Accepts URLs with or without http(s)://, basic domain validation
							// Regex: must have at least one dot, valid domain chars, optional path/query/hash
							const urlPattern =
								/^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/.*)?$/;
							return (
								urlPattern.test(value) || "Please enter a valid website URL"
							);
						},
					})}
					className="w-full border-b border-gray-300 focus:outline-none focus:border-lime-500 pb-2"
				/>
				{errors.website && (
					<span className="text-red-500 text-xs">Website is required</span>
				)}

				{/* Role/Job Title */}
				<input
					type="text"
					placeholder="Role / Job Title"
					{...register("role", { required: true })}
					className="w-full border-b border-gray-300 focus:outline-none focus:border-lime-500 pb-2"
				/>
				{errors.role && (
					<span className="text-red-500 text-xs">
						Role/Job Title is required
					</span>
				)}

				{/* Email */}

				<input
					type="email"
					placeholder="Work Email"
					{...register("email", { required: true })}
					className="w-full border-b border-gray-300 focus:outline-none focus:border-lime-500 pb-2"
				/>
				{errors.email && (
					<span className="text-red-500 text-xs">Email is required</span>
				)}

				{/* Phone */}
				<input
					type="tel"
					placeholder="Phone"
					{...register("phone", { required: true })}
					className="w-full border-b border-gray-300 focus:outline-none focus:border-lime-500 pb-2"
				/>
				{errors.phone && (
					<p className="text-red-500 text-xs">Phone is required</p>
				)}

				{/* Linkedin URL */}
				<input
					type="text"
					placeholder="Linkedin Profile"
					{...register("linkedin", {
						required: false,
						validate: (value: string) => {
							if (!value) return true; // Optional: skip validation if empty
							const urlPattern =
								/^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/.*)?$/;
							return (
								urlPattern.test(value) || "Please enter a valid Linkedin URL"
							);
						},
					})}
					className="w-full border-b border-gray-300 focus:outline-none focus:border-lime-500 pb-2"
				/>
				{errors.linkedin && (
					<p className="text-red-500 text-xs">
						Please enter a valid Linkedin profile URL
					</p>
				)}

				{/* Goals (Textarea) */}
				<textarea
					placeholder="Describe your key sales and marketing goals"
					{...register("goals", { required: true })}
					rows={4}
					className="w-full border-b border-gray-300 focus:outline-none focus:border-lime-500 pb-2"
				/>
				{errors.goals && (
					<span className="text-red-500 text-xs">
						Please provide your sales and marketing goals
					</span>
				)}

				{/* Submit */}
				<div>
					<button
						type="submit"
						disabled={isSubmitting}
						className="mt-4 lg:max-w-[40%] w-auto rounded-full bg-brand-green whitespace-nowrap px-6 py-4 text-white font-medium hover:bg-lime-600 transition-colors disabled:opacity-50"
					>
						{isSubmitting ? "Sending..." : "Meet The Experts"}
					</button>
				</div>
			</form>
		</div>
	);
}
